export enum Teams {
    Boom = 'email_campaigns',
    Mag = 'psa_and_growth',
}

export enum Features {
    Subscribers = 'subscribers',
    ManageSubscribers = 'manage_subscribers',
    TaskList = 'task_list',
}

export enum Components {
    ImportList = 'import_a_list',
    NewList = 'new_list',
    PreviousEvents = 'previous_events',
    UploadCSV = 'upload_csv',
    ManualAdd = 'manual_add',
    ManualAddSingle = 'manual_add_single',
    ManualAddMultiple = 'manual_add_multiple',
    AddToFacebook = 'add_to_facebook',
    CreateEventInvite = 'create_event_invite',
    EbAds = 'eb_ads',
    FacebookAdCampaign = 'facebook_ad_campaign',
    VisitEventbriteAcademy = 'visit_eventbrite_academy',
    SendEmailCampaign = 'email_campaign',
    CompleteProfile = 'complete_profile',
    InstagramGrowthCampaign = 'instagram_growth',
}

export enum Actions {
    Start = 'start',
    ChooseFile = 'choose_file',
    Submit = 'submit',
    Create = 'create',
    Manage = 'manage',
}
